import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import {
  getDataEndPoint,
  updateDataEndPoint,
  createUpdateAudiencePixelEndPoint,
  deleteAudiencePixelEndPoint,
} from "app/utils/constants/paths";
import { DATASOURCE_CONFIG } from "app/config";
import cloneDeep from "lodash.clonedeep";
let tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;

const initialState = {
  loading: false,
  audiencePixelsList: [],
  audiencepixelFilterFormValues: {
    organizations: [],
    accounts: [],
  },
  audiencepixelFilters: {
    organizations: [],
    accounts: [],
  },
};
export const GetAllAudiencePixelsListThunk = createAsyncThunk(
  "audiencePixels/GetAllAudiencePixelsListThunk",
  async (payload) => {
    console.log("Authentication:", payload?.authUserData);
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    var audiencepixelFilters = payload?.audiencepixelFilters;
    let where = "";
    if (isSysAdmin != 1) {
      // For Non-System Admin User
      let authAdvAccounts = payload?.authUserData?.user_assoc_accounts
        ?.advertiser
        ? payload.authUserData?.user_assoc_accounts?.advertiser
        : [];
      const userAdvList = payload?.authUserData?.user_assoc_advertisers;
      //id IN ('" + authAccounts.join("','") + "')

      // where =
      //   " and asp.provider=ap.code and  asp.customsegment_accountid IN('" +
      //   authAdvAccounts.join("','") +
      //   "') and asp.advertiserid IN('0," +
      //   userAdvList.join("','") +
      //   "')";

      let fAccounts =
        audiencepixelFilters?.accounts.length > 0
          ? audiencepixelFilters?.accounts.join("','")
          : authAdvAccounts.join("','");

      where +=
        " and  asp.customsegment_accountid IN('" +
        fAccounts +
        "') and asp.advertiserid IN('0','','" +
        userAdvList.join("','") +
        "')";

      if (audiencepixelFilters?.organizations.length > 0) {
        // Add additional conditions to 'where' clause
        where +=
          " and acc.company_id IN('" +
          audiencepixelFilters?.organizations.join("','") +
          "') ";
      }
    } else {
      if (audiencepixelFilters?.accounts.length) {
        // Add condition for accounts if organizations are not present
        where +=
          " and asp.customsegment_accountid IN('" +
          audiencepixelFilters?.accounts.join("','") +
          "') ";
      }
      if (audiencepixelFilters?.organizations.length > 0) {
        // Add additional conditions to 'where' clause
        where +=
          " and acc.company_id IN('" +
          audiencepixelFilters?.organizations.join("','") +
          "') ";
      }
    }

    let pixelQry = "";
    if (audiencepixelFilters?.organizations.length > 0) {
      // Construct the SQL query based on the conditions
      pixelQry =
        "SELECT asp.segment AS id, asp.segment, asp.provider, asp.price, asp.pixel, asp.segment_name, asp.site_id, asp.account_access, DATE_FORMAT(asp.expiry_date,'%Y-%m-%d %H:%i:%s') AS expiry_date, asp.customsegment_accountid, ap.name AS provider, SUM(ascn.uniques) AS uniques, acc.company AS account_name" +
        " FROM " +
        tablePrefix +
        "audience_segments_providers AS asp" +
        " JOIN " +
        tablePrefix +
        "audience_provider_details AS ap ON asp.provider = ap.code" +
        " LEFT JOIN " +
        tablePrefix +
        "audience_segments_providers_counts AS ascn ON asp.segment = ascn.segment" +
        " INNER JOIN " +
        tablePrefix +
        "accounts AS acc ON asp.customsegment_accountid = acc.id " +
        " where asp.provider IN('mobqcustom') and asp.is_customsegment=1 and asp.is_active=1 and (asp.expiry_date >= now() OR asp.expiry_date='0000-00-00 00:00:00') " +
        where +
        " and asp.customsegment_accountid != ''  GROUP BY asp.segment ORDER BY asp.created_at DESC;";
    } else {
      // Construct the SQL query without organization filters
      pixelQry =
        "select asp.segment as id,asp.segment,asp.provider,asp.price,asp.pixel,asp.segment_name,asp.site_id,asp.account_access,DATE_FORMAT(asp.expiry_date,'%Y-%m-%d %H:%i:%s') as expiry_date,asp.customsegment_accountid,ap.name as provider,SUM(ascn.uniques) AS uniques, (select company from accounts where id=asp.customsegment_accountid) as account_name" +
        " from " +
        tablePrefix +
        "audience_segments_providers as asp JOIN " +
        tablePrefix +
        "audience_provider_details AS ap ON asp.provider=ap.code LEFT JOIN " +
        tablePrefix +
        "audience_segments_providers_counts AS `ascn` ON asp.segment = ascn.segment " +
        "where asp.provider IN('mobqcustom') and asp.is_customsegment=1 and asp.is_active=1 and (asp.expiry_date >= now() OR asp.expiry_date='0000-00-00 00:00:00') " +
        where + // This might be causing the issue if 'where' is undefined here
        " GROUP BY asp.segment  order by asp.created_at desc;";
    }

    // Make sure 'pixelQry' is properly constructed and passed to your database query executor

    const queryBody = {
      queries: [
        {
          query: pixelQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAudiencePixelDetailsThunk = createAsyncThunk(
  "advertiser/GetAudiencePixelDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select asp.segment,asp.customsegment_accountid,asp.advertiserid,asp.segment_name,asp.site_id,asp.price,asp.is_conversionpixel_generated as conversion_pixel,DATE_FORMAT(asp.expiry_date,'%Y-%m-%d %H:%i:%s') as expiry_date from " +
            tablePrefix +
            "audience_segments_providers as asp where segment='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const InsertUpdateAudienceFixelDetailsThunk = createAsyncThunk(
  "advertiser/InsertUpdateAudienceFixelDetailsThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        createUpdateAudiencePixelEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const DeleteAudiencePixelThunk = createAsyncThunk(
  "advertiser/DeleteAudiencePixelThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        deleteAudiencePixelEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
const AudiencePixels = createSlice({
  name: "audiencePixels",
  initialState,
  reducers: {
    updateAudiencepixelFiltersFormValues(state, action) {
      let audiencepixelFilters = cloneDeep(state.audiencepixelFilterFormValues);
      if (action.payload?.action == "delete") {
        audiencepixelFilters = {
          organizations: [],
          accounts: [],
        };
      } else {
        let type = action.payload.type;
        let data = action.payload.data;
        audiencepixelFilters[type] = data;
      }

      state.audiencepixelFilterFormValues = audiencepixelFilters;
    },
    updateAudiencepixelFilters(state, action) {
      let audiencepixelFilters = cloneDeep(state.audiencepixelFilters);
      audiencepixelFilters.organizations = action.payload.organizations;
      audiencepixelFilters.accounts = action.payload.accounts;

      state.audiencepixelFilters = audiencepixelFilters;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(GetAllAudiencePixelsListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllAudiencePixelsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0]) {
          state.audiencePixelsList = Array.isArray(action.payload.data?.results[0]) ? action.payload.data.results[0].filter((row) => row && row.id) : [];
        }
        state.loading = false;
      })
      .addCase(GetAllAudiencePixelsListThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(GetAudiencePixelDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAudiencePixelDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0]) {
          //state.audiencePixelsList = action.payload.data.results[0];
        }
        state.loading = false;
      })
      .addCase(GetAudiencePixelDetailsThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(InsertUpdateAudienceFixelDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(InsertUpdateAudienceFixelDetailsThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(InsertUpdateAudienceFixelDetailsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(DeleteAudiencePixelThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(DeleteAudiencePixelThunk.fulfilled, (state, action) => {
        let audiencePixelsList = state.audiencePixelsList;
        let segId = action.meta.arg.segmentcode;

        // advertiserList = advertiserList.filter((item) => item.id !== advId);
        state.audiencePixelsList = audiencePixelsList.filter((info) => {
          return info.segment != segId;
        });
        state.loading = false;
      })
      .addCase(DeleteAudiencePixelThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});
const { actions, reducer } = AudiencePixels;
// Extract and export each action creator by name
export const {
  updateAudiencepixelFiltersFormValues,
  updateAudiencepixelFilters,
} = actions;
// Export the reducer, either as a default or named export
export default reducer;
